module.exports = __webpack_public_path__ + "img/0028.f0579973.jpg";